import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import heroImage from "./../../../assets/images/advaned-growhair1.jpg";
import favicon from "./../../../assets/images/favicon.ico"; // Make sure to import favicon

import "./advancedhair.css";
//bannerimg
import gfc1 from "./../../../assets/images/advanced-gfc.jpg";
//before and after
import gfc2 from "./../../../assets/images/advanced-gfc2.jpg";
import gfc3 from "./../../../assets/images/advanced-gfc3.jpg";
import gfc4 from "./../../../assets/images/advanced-gfc4.jpg";

// Import icons
import groHairIcon from "./../../../assets/images/grow-hair treatment-icons.png";
import prpIcon from "./../../../assets/images/prp-treatment-icons1.png";
import gfcIcon from "./../../../assets/images/gfc-treatment-icons.png";
import stmIcon from "./../../../assets/images/treatment.png";
import laserIcon from "./../../../assets/images/laserhair.png";
import AutoScrollImageRow from "./AutoScrollImageRow";


const treatments = [
  { name: "GROHAIR TREATMENT", navName: "GROHAIR" },
  { name: "PRP TREATMENT", navName: "PRP" },
  { name: "GFC TREATMENT", navName: "GFC" },
  { name: "STM TREATMENT", navName: "STM" },
  { name: "LASER TREATMENT", navName: "LASER" },
];

const treatmentIconPNGMap = {
  GROHAIR: groHairIcon,
  PRP: prpIcon,
  GFC: gfcIcon,
  STM: stmIcon,
  LASER: laserIcon,
};

const images = [
  { 
    src: gfc2, 
    alt: "Before and After GFC Hair Treatment Results", 
    title: "Hair GFC Treatment In Bangalore Under low price"
  },
  { 
    src: gfc3, 
    alt: "GFC Hair Restoration Process", 
    title: "Hair GFC Treatment In Chennai Under low price"
  },
  { 
    src: gfc4, 
    alt: "Growth Factor Hair Treatment Equipment", 
    title: "Hair GFC Clinic near me"
  },
  // Add more images as needed
];

const gfcFaqData = [
  {
    q: "What is GFC hair treatment, and how does it support hair regrowth?",
    a: "GFC (Growth Factor Concentrate) therapy is an advanced, autologous treatment that uses highly purified growth factors derived from your own blood to reactivate dormant follicles, minimize thinning, and promote natural hair regrowth.",
  },
  {
    q: "Is GFC therapy more effective than PRP for hair restoration?",
    a: "Yes. GFC contains a higher concentration of active growth proteins compared to conventional PRP, resulting in faster response, improved follicle stimulation, and more noticeable enhancement in hair density.",
  },
  {
    q: "Who is an ideal candidate for GFC hair therapy?",
    a: "GFC therapy is suitable for both men and women experiencing early to moderate hair thinning, androgenetic alopecia, or hair shedding following illness or stress.",
  },
  {
    q: "How is GFC hair treatment performed at H-Cura Clinic?",
    a: "At H-Cura, a small blood sample is collected, processed to extract concentrated growth factors, and gently administered to areas of thinning to stimulate follicular activity and encourage regrowth.",
  },
  {
    q: "How many GFC sessions are required for noticeable improvement?",
    a: "Most patients observe visible improvement after 3 to 5 sessions, typically spaced several weeks apart, depending on the severity of hair loss and individual response.",
  },
  {
    q: "Is GFC hair therapy safe for all hair and scalp types?",
    a: "Yes. GFC is an autologous, minimally invasive treatment that is safe for all hair types and is adapted to each patient’s scalp condition for optimal outcomes.",
  },
  {
    q: "What are the primary benefits of GFC hair treatment?",
    a: "GFC therapy helps reduce hair fall, strengthens hair roots, enhances follicle function, improves scalp health, and supports the natural growth of thicker, healthier hair.",
  },
  {
    q: "Can GFC treatment help prevent future hair loss?",
    a: "Regular GFC sessions can fortify hair follicles and slow the progression of hair thinning, contributing to long-term scalp and hair stability.",
  },
  {
    q: "Where can I get advanced GFC hair treatment near me?",
    a: "H-Cura offers clinically advanced GFC hair therapy at its Bangalore (Jayanagar) and Chennai (Madhanandapuram & Valasaravakkam) centers, delivered by trained hair restoration specialists.",
  },
  {
    q: "When will I start seeing results from GFC therapy?",
    a: "Many patients notice reduced hair fall and improved scalp condition within a few weeks, with fuller, denser hair becoming visible after multiple treatment sessions.",
  },
];


// Schema Data
const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  "name": "H-Cura Multispeciality Clinic",
  "url": "https://www.h-cura.com/",
  "potentialAction": {
    "@type": "SearchAction",
    "target": "https://www.h-cura.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string"
  }
};

const localBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "MedicalBusiness",
  "name": "H-Cura Multispeciality Clinic",
  "image": "https://www.h-cura.com/assets/images/logo.png",
  "url": "https://www.h-cura.com",
      "telephone": "+91-8870001377",
  "priceRange": "₹₹",
  "address": [
    {
      "@type": "PostalAddress",
      "streetAddress": "Jayanagar",
      "addressLocality": "Bangalore",
      "addressRegion": "Karnataka",
      "postalCode": "560041",
      "addressCountry": "IN"
    },
    {
      "@type": "PostalAddress",
      "streetAddress": "Madhanandapuram",
      "addressLocality": "Chennai",
      "addressRegion": "Tamil Nadu",
      "postalCode": "600125",
      "addressCountry": "IN"
    },
    {
      "@type": "PostalAddress",
      "streetAddress": "Valasaravakkam",
      "addressLocality": "Chennai",
      "addressRegion": "Tamil Nadu",
      "postalCode": "600087",
      "addressCountry": "IN"
    }
  ],
  "openingHoursSpecification": [
    {
      "@type": "OpeningHoursSpecification",
      "dayOfWeek": ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      "opens": "10:00",
      "closes": "20:00"
    }
  ],
  "sameAs": [
    "https://www.facebook.com/hcuraclinic",
    "https://twitter.com/hcuraclinic",
    "https://www.instagram.com/hcuraclinic"
  ]
};

const serviceSchema = {
  "@context": "https://schema.org",
  "@type": "MedicalTherapy",
  "name": "GFC Hair Treatment",
  "alternateName": "Growth Factor Concentrate Hair Therapy",
  "description": "Advanced GFC hair treatment uses concentrated growth factors from your blood to stimulate hair follicles, reduce hair fall, and promote natural hair regrowth.",
  "url": "https://www.h-cura.com/advanced-hair-gfc-treatment",
  "medicineSystem": "Conventional",
  "relevantSpecialty": "Dermatology",
  "study": {
    "@type": "MedicalStudy",
    "healthCondition": "Hair Loss",
    "status": "Completed",
    "studyLocation": "H-Cura Multispeciality Clinic",
    "description": "Clinical studies have shown up to 40% improvement in hair density after a series of GFC treatments."
  },
  "adverseOutcome": "Minimal side effects include temporary scalp sensitivity and mild discomfort during the procedure.",
  "guideline": "Treatment is administered in 3-5 sessions spaced several weeks apart for optimal results."
};

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": gfcFaqData.map(faq => ({
    "@type": "Question",
    "name": faq.q,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.a
    }
  }))
};

const medicalBusinessSchema = {
  "@context": "https://schema.org",
  "@type": "MedicalBusiness",
  "name": "H-Cura Multispeciality Clinic",
  "image": "https://www.h-cura.com/assets/images/logo.png",
  "url": "https://www.h-cura.com",
      "telephone": "+91-8870001377",
  "medicalSpecialty": ["Dermatology", "Trichology", "HairRestoration"],
  "address": [
    {
      "@type": "PostalAddress",
      "streetAddress": "Jayanagar",
      "addressLocality": "Bangalore",
      "addressRegion": "Karnataka",
      "postalCode": "560041",
      "addressCountry": "IN"
    },
    {
      "@type": "PostalAddress",
      "streetAddress": "Madhanandapuram & Valasaravakkam",
      "addressLocality": "Chennai",
      "addressRegion": "Tamil Nadu",
      "postalCode": "600125",
      "addressCountry": "IN"
    }
  ],
  "availableService": [
    {
      "@type": "MedicalTherapy",
      "name": "GFC Hair Treatment",
      "description": "Advanced Growth Factor Concentrate therapy for hair regrowth"
    },
    {
      "@type": "MedicalTherapy",
      "name": "PRP Hair Treatment",
      "description": "Platelet-Rich Plasma therapy for hair restoration"
    },
    {
      "@type": "MedicalTherapy",
      "name": "Laser Hair Therapy",
      "description": "Low-level laser treatment for hair follicle stimulation"
    }
  ],
  "medicalAudience": {
    "@type": "MedicalAudience",
    "audienceType": "Patients with hair loss and thinning concerns"
  },
  "isAcceptingNewPatients": true
};

function GfcHair() {
  // Changed from Gfchair to Hair for consistency
  const [activeTab, setActiveTab] = useState("GFC TREATMENT");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalImage, setModalImage] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    document.title =
      "Advanced GFC Hair Treatment in Bangalore & Chennai – H‑Cura";
    const metaDescription = document.querySelector("meta[name='description']");
    if (metaDescription) {
      metaDescription.setAttribute(
        "content",
        "Get advanced GFC hair treatment in Bangalore & Chennai at H‑Cura. Stimulate hair regrowth naturally with expert care. Book your consultation today!"
      );
    }
    const metaKeywords = document.querySelector("meta[name='keywords']");
    if (metaKeywords) {
      metaKeywords.setAttribute(
        "content",
        "GFC treatment in Bangalore,Best GFC therapy for hair regrowth,Growth Factor Concentrate hair treatment,Advanced hair restoration Bangalore,hair loss treatment,Hair thinning solution GFC,Effective hair regrowth therapy,GFC hair treatment clinic Bangalore,GFC treatment in Bangalore,Best GFC therapy for hair regrowth,Growth Factor Concentrate hair treatment,Advanced hair restoration Bangalore,hair loss treatment,Hair thinning solution GFC,Effective hair regrowth therapy,GFC hair treatment clinic Bangalore,"
      );
    }
    // Set canonical link
    const existingCanonical = document.querySelector("link[rel='canonical']");
    if (existingCanonical) {
      existingCanonical.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-hair-gfc-treatment"
      );
    } else {
      const canonicalLink = document.createElement("link");
      canonicalLink.setAttribute("rel", "canonical");
      canonicalLink.setAttribute(
        "href",
        "https://www.h-cura.com/advanced-gfc-treatment"
      );
      document.head.appendChild(canonicalLink);
    }
    // Set favicon
    const existingFavicon = document.querySelector("link[rel='icon']");
    if (existingFavicon) {
      existingFavicon.setAttribute("href", favicon);
    } else {
      const faviconLink = document.createElement("link");
      faviconLink.setAttribute("rel", "icon");
      faviconLink.setAttribute("type", "image/x-icon");
      faviconLink.setAttribute("href", favicon);
      document.head.appendChild(faviconLink);
    }

    // Add Schema.org structured data
    const addJsonLdScript = (schemaData) => {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.text = JSON.stringify(schemaData);
      document.head.appendChild(script);
    };

    // Add all schemas
    addJsonLdScript(websiteSchema);
    addJsonLdScript(localBusinessSchema);
    addJsonLdScript(serviceSchema);
    addJsonLdScript(faqSchema);
    addJsonLdScript(medicalBusinessSchema);

    return () => {
      // Clean up schema scripts when component unmounts
      document.querySelectorAll('script[type="application/ld+json"]').forEach(script => {
        document.head.removeChild(script);
      });
    };
  }, []);

  useEffect(() => {
    // Get the current path from window.location
    const path = window.location.pathname;

    // Extract the treatment name from the path
    const pathSegments = path.split("/");
    const currentPage = pathSegments[pathSegments.length - 1]?.toLowerCase();

    // Find the matching treatment based on the URL path
    if (currentPage) {
      const matchingTreatment = treatments.find(
        (treatment) => treatment.navName.toLowerCase() === currentPage
      );

      if (matchingTreatment) {
        setActiveTab(matchingTreatment.name);
      }
    }

    // Original effect code for process steps
    const steps = document.querySelectorAll(".hc-process-step");
    steps.forEach((step, index) => {
      step.style.setProperty("--index", index);
      step.style.opacity = "1";
    });
  }, []);

  const renderTreatmentIcon = (name, fallbackIcon) => {
    // Extract the base name for icon lookup
    return treatmentIconPNGMap[name] ? (
      <img
        src={treatmentIconPNGMap[name]}
        alt={`${name} Treatment Icon`}
        title={`${name} Hair Treatment at H-Cura`}
        style={{ width: "100px", height: "100px" }}
      />
    ) : (
      fallbackIcon
    );
  };

  const openModal = (image) => {
    setModalImage(image);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalImage(null);
  };

  const handleTreatmentClick = (treatment) => {
    setActiveTab(treatment.name);
    // Map treatment names to specific URLs
    const treatmentUrlMap = {
      "GROHAIR TREATMENT": "/advanced-grow-hair-treatment",
      "PRP TREATMENT": "/advanced-hair-prp-treatment",
      "GFC TREATMENT": "/advanced-hair-gfc-treatment",
      "STM TREATMENT": "/advanced-stm-treatment",
      "LASER TREATMENT": "/advanced-laser-treatment",
    };

    // Use the mapped URL if available, otherwise fallback to the original pattern
    const url =
      treatmentUrlMap[treatment.name] ||
      `/home/${treatment.navName.toLowerCase()}`;
    console.log("Navigating to:", url); // Debug log
    navigate(url);
  };

  return (
    <div className="hc-wrapper">
      {/* New Navigation Section */}
      <div className="hc-treatment-nav-container">
        <h2>Explore Our Treatments</h2>
        <div className="hc-treatment-nav-cards">
          {treatments.map((treatment) => {
            const [treatmentName, treatmentSuffix] = treatment.name.split(" ");
            return (
              <div
                key={treatment.name}
                className={`hc-treatment-nav-card ${
                  activeTab === treatment.name ? "active" : ""
                }`}
                style={{
                  position: "relative",
                  borderBottom:
                    activeTab === treatment.name ? "3px solid #007bff" : "none",
                  transition: "border-bottom 0.3s ease",
                }}
                onClick={() => handleTreatmentClick(treatment)}
              >
                <div className="hc-card-icon">
                  {renderTreatmentIcon(treatment.navName)}
                </div>
                <div className="hc-card-title">
                  <span style={{ color: "#007bff" }}>{treatmentName}</span>{" "}
                  {treatmentSuffix}
                </div>
              </div>
            );
          })}
        </div>
      </div>

      {/* Hero Section */}
         {/* Hero Section */}
<section
  className="hc-hero"
  style={{
    position: "relative",
    backgroundImage: `linear-gradient(rgba(0,0,0,0.5), rgba(0,0,0,0.5)), url(${heroImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }}
>
  {/* Hidden image for SEO & tooltip on hover */}
  <img
    src={heroImage}
    alt="Successful gfc hair treatment clinic near you"
    title="GFC Hair Treatment for hair loss and thinning hair"
    className="hero-seo-img"
  />
  <div className="hc-hero-content">
    <h1 className="hc-hero-title">
      Advanced GFC Hair Treatment in Bangalore & Chennai
    </h1>
    <p className="hc-hero-text">
      Looking for a safe and effective solution for hair loss? At H‑Cura,
      we offer advanced GFC hair treatment in Bangalore and Chennai to
      naturally stimulate hair regrowth, reduce hair fall, and
      restore hair density.
    </p>
    <Link
      to="/bookconsultation"
      style={{ textDecoration: "none" }}
      className="hc-cta-button"
    >
      Book Consultation
    </Link>
  </div>
</section>


      {/* Unique Treatment Navigation Tabs */}

      {/* Treatment Section */}
      <section className="hc-treatment-section" id="treatments">
        <div className="hc-treatment-container">
          <div className="hc-treatment-nav">
            <h2>Revitalize Your Hair with Our Advanced Treatments</h2>
            <p className="hc-nav-description">
              From growth factor enhancements to exclusive GFC therapies, each
              treatment is engineered to kickstart your natural hair regrowth.
            </p>
            <ul>
              <li className="hc-active">
                <strong>Gro Hair Therapy</strong>
                <p>Stimulate hair follicles & helps in hair regrowth.</p>
                <ul className="hc-treatment-details">
                  <li>painless proess & noninvasive procedure</li>
                  <li>helps in control hairfall</li>
                  <li>Quick visible results</li>
                  <li>reduce dandruff</li>
                </ul>
              </li>
              <li className="hc-active">
                <strong>Growth Factor Concentrate</strong>
                <p>Stimulate hair follicles & helps in hair regrowth.</p>
                <ul className="hc-treatment-details">
                  <li>Clinical proven and tested</li>
                  <li>Minimal procedure</li>
                  <li>Quick visible results</li>
                  <li>
                    Enrich with Biotin, Zinc, Minerals and other Vitamins
                  </li>
                </ul>
              </li>
              <li>
                <strong>PRP Therapy</strong>
                <p>
                  Restore your hair naturally by plasma rich protein therapy.
                </p>
                <ul className="hc-treatment-details">
                  <li>Autologous treatment</li>
                  <li>No synthetic additives</li>
                  <li>Boosts regeneration</li>
                </ul>
              </li>

              <li>
                <strong>Stem Cell Treatment</strong>
                <p>Rejuvenate your hair using regenerative technology.</p>
                <ul className="hc-treatment-details">
                  <li>Based on plant poly peptides </li>
                  <li>Supports tissue repair</li>
                  <li>Long-lasting results</li>
                </ul>
              </li>
              <li>
                <strong>Laser Hair Therapy</strong>
                <p>Enhance hair density with precision laser treatments.</p>
                <ul className="hc-treatment-details">
                  <li>Pain-free procedure</li>
                  <li>It stimulate hair follicles</li>
                  <li>hair boosting therapy</li>
                  <li>Quick sessions</li>
                </ul>
              </li>
            </ul>
            <p className="hc-treatment-description-text">
              Our state-of-the-art therapies are administered by experienced
              specialists.
            </p>
            <p className="hc-treatment-extra-info">
              Book a consultation today to create your personalized treatment
              plan.
            </p>
          </div>

          <div className="hc-treatment-content">
            <h3>
              {" "}
              Restore Your Hair Naturally with Advanced GFC Therapy at H-Cura
            </h3>
            <div className="hc-treatment-info">
              <div className="hc-treatment-images">
                <img
                  src={gfc1}
                  alt="Advanced GFC Hair Restoration Treatment Process"
                  title="Best hair gfc Treatment In Bangalore And Chennai"
                  className="hc-main-treatment-image"
                />
                <div className="hc-treatment-gallery">
                  {images.map((image, index) => (
                    <img
                      key={index}
                      src={image.src}
                      alt={image.alt}
                      title={image.title}
                      onClick={() => openModal(image)}
                    />
                  ))}
                </div>
                <div className="hc-treatment-highlight-info">
                  Looking for a reliable solution to control hair fall and boost
                  hair regrowth? At H‑Cura Multispeciality Clinic, we provide
                  advanced GFC hair treatment in Bangalore and Chennai, designed
                  to activate dormant hair follicles, reduce shedding, and
                  promote healthy hair growth naturally. Our expert
                  dermatologists use Growth Factor Concentrate (GFC) therapy – a
                  highly effective, non-surgical treatment – to deliver faster,
                  long-lasting results.
                </div>
              </div>

              <div className="hc-treatment-description">
                <h4>Clinically Advanced Technology for Hair Restoration</h4>
                <div className="hc-treatment-intro">
                  <Link
                    to="/bookconsultation"
                    style={{ textDecoration: "none" }}
                  >
                    <span className="hc-highlight-tag">Advanced Treatment</span>
                  </Link>
                  <p className="hc-lead-text">
                    Experience the future of hair restoration with our
                    FDA-approved Growth Factor Treatment.
                  </p>
                </div>

                <div className="hc-key-benefits">
  <h5>How This Treatment Enhances Your Hair</h5>
  <p>
    Our clinically refined therapy uses concentrated growth factors and essential bio-proteins to deliver noticeable improvements in hair health.
  </p>

  <ul>
    <li>
      <span className="hc-benefit-icon">🔬</span>
      <strong>Activates Hair Follicles</strong>
      <p>Reawakens inactive follicles to initiate new growth.</p>
    </li>

    <li>
      <span className="hc-benefit-icon">📈</span>
      <strong>Improves Hair Density</strong>
      <p>Enhances thickness and volume with measurable results.</p>
    </li>

    <li>
      <span className="hc-benefit-icon">🌱</span>
      <strong>Supports Natural Regrowth</strong>
      <p>Encourages a healthy, natural growth cycle over time.</p>
    </li>

    <li>
      <span className="hc-benefit-icon">💪</span>
      <strong>Strengthens Existing Hair</strong>
      <p>Reduces breakage and boosts overall hair resilience.</p>
    </li>
  </ul>
</div>


                <div className="hc-treatment-highlights">
                  <div className="hc-highlight-box">
                    <h5>Success Rate</h5>
                    <p>95%</p>
                    <span className="hc-subtitle">Satisfied Clients</span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Treatment Time</h5>
                    <p>60 mins</p>
                    <span className="hc-subtitle">Per Session</span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Recovery</h5>
                    <p>min to max</p>
                    <span className="hc-subtitle">
                      depends upon person to person{" "}
                    </span>
                  </div>
                  <div className="hc-highlight-box">
                    <h5>Result</h5>
                    <p>6-10 sessions</p>
                    <span className="hc-subtitle">for visible results</span>
                  </div>
                </div>

                <Link to="/bookconsultation" style={{ textDecoration: "none" }}>
                  <button className="hc-book-treatment-btn">
                    Schedule Your Consultation
                    <span className="hc-btn-icon">→</span>
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

     <section className="hc-process-section prp-treatment-simple">
  <div className="prp-treatment-wrapper">
    <div className="hc-benefits-header">
      <div className="hc-section-tag">Hair GFC Treatment</div>
      <h2>What Is GFC (Growth Factor Concentrate) Hair Therapy?</h2>
    </div>

    <p>
      GFC hair therapy is an advanced, clinically designed treatment for hair
      fall and thinning. It uses highly concentrated growth factors extracted
      from your own blood to revive weakened hair follicles and promote natural
      regrowth. Compared to standard PRP, GFC delivers a more potent dose of
      growth proteins, resulting in faster and more effective outcomes.
    </p>

    <p> ✔ Suitable for:</p>

    <ul>
      <li>Men and women experiencing pattern baldness</li>
      <li>Individuals with progressive hair thinning</li>
      <li>Recovery from post-illness or post-COVID hair fall</li>
    </ul>

    <p>
      The outcome? Healthier follicles, improved hair density, and naturally
      stronger, fuller-looking hair.
    </p>
  </div>
</section>


      {/* Benefits Section */}
      <section className="hc-benefits-section">
  <div className="hc-benefits-header">
    <span className="hc-section-tag">Why Choose Us</span>
    <h2>Clinical Excellence in Hair Restoration at H-Cura Multispeciality Clinic</h2>
    <p className="hc-section-subtitle">
      Our treatment protocols integrate advanced medical technology with individualized care,
      ensuring safe, effective, and scientifically guided hair restoration.
    </p>
  </div>

  <div className="hc-benefits-grid">
    {[
      {
        icon: "🔬",
        title: "Advanced Medical Technology",
        desc: "We utilize high-precision GFC and growth factor systems engineered for superior follicular stimulation.",
        features: [
          "Evidence-Based Treatment Protocols",
          "FDA-Compliant Systems",
          "Clinically Validated Outcomes",
        ],
      },
      {
        icon: "👨‍⚕",
        title: "Specialized Medical Team",
        desc: "Our clinical team consists of trained hair restoration specialists with extensive expertise in regenerative therapies.",
        features: [
          "Certified Dermatology Experts",
          "Years of Clinical Experience",
          "Personalized Medical Guidance",
        ],
      },
      {
        icon: "🎯",
        title: "Patient-Specific Treatment Plans",
        desc: "Therapies are customized to each patient’s scalp condition, biology, and hair restoration goals.",
        features: [
          "Individualized Therapy Sessions",
          "Ongoing Response Monitoring",
          "Optimized Treatment Scheduling",
        ],
      },
      {
        icon: "✨",
        title: "Natural & Predictable Results",
        desc: "Our clinical approach ensures natural-looking outcomes with improved density and long-term stability.",
        features: [
          "Gradual, Natural Enhancements",
          "Sustained Clinical Benefits",
          "Improved Hair Quality & Strength",
        ],
      },
      {
        icon: "🛡",
        title: "Strict Safety & Hygiene Standards",
        desc: "All procedures follow stringent clinical protocols to ensure complete patient safety and sterile environments.",
        features: [
          "Medical-Grade Sterilization",
          "Adherence to Safety Guidelines",
          "Patient-Focused Care Practices",
        ],
      },
      {
        icon: "💯",
        title: "High Clinical Success Rate",
        desc: "Thousands of treated patients have demonstrated significant improvement in hair density and scalp health.",
        features: [
          "Over 5,000 Satisfied Patients",
          "Consistently Positive Clinical Results",
          "High Retreatment Satisfaction Rate",
        ],
      },
    ].map((benefit, index) => (
      <div className="hc-benefit-card" key={index}>
        <div className="hc-benefit-icon">{benefit.icon}</div>
        <div className="hc-benefit-content">
          <h3>{benefit.title}</h3>
          <p>{benefit.desc}</p>
          <ul className="hc-feature-list">
            {benefit.features.map((feature, idx) => (
              <li key={idx}>{feature}</li>
            ))}
          </ul>
        </div>
      </div>
    ))}
  </div>
</section>


      {/* Process Section */}
     <section className="hc-process-section" id="process">
  <div className="hc-process-header">
    <span className="hc-process-tag">Our Process</span>
    <h2>Your Clinical Pathway to Fuller, Healthier Hair</h2>
    <p className="hc-process-subtitle">
      Follow our structured, evidence-based 4-step protocol designed to deliver
      safe, consistent, and long-lasting hair restoration outcomes.
    </p>
  </div>

  <div className="hc-process-timeline">
    {[
      {
        step: "01",
        title: "Comprehensive Clinical Evaluation",
        desc: "Your treatment begins with a detailed assessment of your scalp health, medical profile, and hair loss pattern.",
        details: [
          "Advanced scalp and follicular analysis",
          "Complete medical and lifestyle review",
          "Diagnosis-based treatment planning",
          "Clear expectation and outcome discussion",
        ],
        icon: "🔍",
      },
      {
        step: "02",
        title: "Personalized Treatment Planning",
        desc: "A customized GFC therapy plan is formulated based on your diagnostic findings and clinical goals.",
        details: [
          "Individualized protocol design",
          "Optimized growth factor concentration",
          "Structured session scheduling",
          "Guidance on hair-supportive lifestyle habits",
        ],
        icon: "📋",
      },
      {
        step: "03",
        title: "Precision GFC Procedure",
        desc: "Our specialists administer highly concentrated growth factors using controlled, targeted techniques to stimulate follicular activity.",
        details: [
          "Strict sterile preparation",
          "Precision-based GFC delivery",
          "Focused activation of dormant follicles",
          "Comfort-oriented clinical procedure",
        ],
        icon: "💉",
      },
      {
        step: "04",
        title: "Ongoing Clinical Monitoring",
        desc: "We provide structured follow-up care to track progress, refine the protocol, and maintain long-term hair improvement.",
        details: [
          "Regular progress assessments",
          "Adjustment of treatment intensity",
          "Maintenance and booster recommendations",
          "Continuous clinical support",
        ],
        icon: "📈",
      },
    ].map((process, index) => (
      <div className="hc-process-step" key={index}>
        <div className="hc-step-container">
          <div className="hc-step-number-container">
            <div className="hc-step-number">{process.step}</div>
            <div className="hc-step-icon">{process.icon}</div>
          </div>
          <div className="hc-step-content">
            <h3>{process.title}</h3>
            <p className="hc-step-description">{process.desc}</p>
            <ul className="hc-step-details">
              {process.details.map((detail, idx) => (
                <li key={idx}>{detail}</li>
              ))}
            </ul>
          </div>
        </div>
        {index < 3 && <div className="hc-connector-line"></div>}
      </div>
    ))}
  </div>
</section>



     {/* GFC FAQ Section */}
<section className="hc-faq-section">
  <div className="hc-faq-header">
    <span className="hc-section-tag">GFC FAQs</span>
    <h2 className="hc-faq-title">FAQs About Advanced GFC Hair Treatment in Bangalore & Chennai</h2>
  </div>
  <div className="hc-faq-list">
    {gfcFaqData.map((faq, idx) => (
      <details className="hc-faq-item" key={idx}>
        <summary className="hc-faq-question">
          <span className="hc-faq-q">Q{idx + 1}:</span> {faq.q}
          <span className="hc-faq-toggle-icon">+</span>
        </summary>
        <div className="hc-faq-answer">
          <span className="hc-faq-a">A:</span> {faq.a}
        </div>
      </details>
    ))}
  </div>
</section>

      <AutoScrollImageRow />



      {/* Modal for Image Viewing */}
      {isModalOpen && (
        <div className="hc-modal-overlay" onClick={closeModal}>
          <div
            className="hc-modal-content"
            onClick={(e) => e.stopPropagation()}
          >
            <button className="hc-close-modal" onClick={closeModal}>
              &times;
            </button>
            <img
              src={modalImage?.src}
              alt={modalImage?.alt}
              title={modalImage?.title}
              className="hc-modal-image"
            />
          </div>
        </div>
      )}
    </div>
  );
}

export default GfcHair; // Changed from Gfchair to Hair
